export default {"src":"/_next/static/media/workshopIcon.013fb825.svg","height":160,"width":160,"blurWidth":0,"blurHeight":0};